module.exports = __webpack_public_path__ + "static/dungeoneers-pack-mtg_clb-469f11b9e3cdbaa12bfc4e31419eaeb2.webp";